import React from 'react';
import { useContext } from 'react';
import { useState, useEffect } from 'react';
import variables from '../theme/variables';

const State = React.createContext();

function StateProvider({ children }) {
    const [muted, setMuted] = useState(false);
    const [soundscapeMuted, setSoundscapeMuted] = useState(false);
    const [returnButtonTheme, setReturnButtonTheme] = useState(
        variables.buttonTheme.light
    );
    const [screenOrientation, setScreenOrientation] = useState('desktop');

    useEffect(() => {
        function checkScreenOrientation() {
            const w = window.innerWidth;
            const h = window.innerHeight;

            if (w > 1024) {
                setScreenOrientation('desktop');
                return;
            }

            setScreenOrientation('mobile');
        }

        window.addEventListener('resize', checkScreenOrientation);
        checkScreenOrientation();

        return () => {
            window.removeEventListener('resize', checkScreenOrientation);
        };
    }, []);

    const handleButtonThemeChange = (theme) => {
        if (theme === 'light') {
            setReturnButtonTheme(variables.buttonTheme.light);
        } else if (theme === 'dark') {
            setReturnButtonTheme(variables.buttonTheme.dark);
        } else {
            setReturnButtonTheme(variables.buttonTheme.dark);
        }
    };

    return (
        <State.Provider
            value={{
                muted,
                setMuted,
                soundscapeMuted,
                setSoundscapeMuted,
                returnButtonTheme,
                setReturnButtonTheme: handleButtonThemeChange,
                screenOrientation,
            }}
        >
            {children}
        </State.Provider>
    );
}

const useGlobalState = () => {
    return useContext(State);
};

export { StateProvider, useGlobalState, State };
